<template>
  <v-autocomplete
    id="qrChannel"
    ref="qrChannel"
    clearable
    v-model="selectedChannel"
    :items="channelList"
    item-text="desc"
    item-value="code"
    label="Channel QR *"
    :loading="isLoading"
    :search-input.sync="searchInput"
    :error-messages="channelQrErrors"
    hide-selected
    outlined
    @focus="loadChannelList"
    @change="$v.selectedChannel.$touch()"
    @blur="$v.selectedChannel.$touch()"
  >
    <template v-slot:item="data">
      <template v-if="typeof data.item != 'object'">
        <v-list-item-content>{{ data.item }}</v-list-item-content>
      </template>
      <template v-else>
        <v-list-item-content>
          <v-list-item-title>{{ data.item.code }}</v-list-item-title>
          <v-list-item-subtitle>{{ data.item.desc }}</v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { date } from '../../../lib/helpers';

export default {
  name: 'QrChannelField',
  mixins: [validationMixin],
  
  props: {
    jenisQR: {
      type: [String, Number],
      default: ''
    }
  },
  
  validations: {
    selectedChannel: {
      required
    }
  },
  
  data() {
    return {
      isLoading: false,
      searchInput: '',
      channelListLoaded: false,
    };
  },

  computed: {

    channelCodesAllowed() {
      const mapping = {
        '1': ['000', '521', '600'],                  // QR Sticker
        '2': ['400', '401', '521', '600'],           // QR API
        '3': ['400', '600'],                         // QR EDC
        '4': ['000', '521', '600', '400', '401'],    // QR Sticker & API
        '5': ['000', '521', '600', '400', '401'],    // QR Sticker & API & EDC
        '6': ['000', '400', '521', '600'],           // QR Sticker & EDC
        '7': ['400', '401', '521', '600'],           // QR API & EDC
        '8': []                                      // CPTS
      };
      return mapping[String(this.jenisQR)] || [];
    },

    channelList() {
      const allChannels = this.$store.state.register.channelQrList || [];
      
      // Jika jenisQR kosong, tampilkan semua
      if (!this.jenisQR) return allChannels;
      
      // Filter berdasarkan allowed channel codes
      const allowed = this.channelCodesAllowed;
      if (allowed.length === 0) return []; // CPTS tidak ada mapping
      
      return allChannels.filter(channel => allowed.includes(channel.code));
    },

    selectedChannel: {
      get() {
        return this.$store.state.register.data.channelCode;
      },
      set(val) {
        this.$store.commit('register/setChannelCode', val);
      }
    },

    channelQrErrors() {
      const errors = [];
      if (!this.$v.selectedChannel.$dirty) return errors;
      if (!this.$v.selectedChannel.required) errors.push('Channel QR is required');
      return errors;
    }
  },

  methods: {
    async loadChannelList() {
      if (this.channelListLoaded) return;
      
      this.isLoading = true;
      try {
        await this.$store.dispatch('register/getQRChannelList', { date });
        this.channelListLoaded = true;
      } catch (error) {
        console.error('Error loading channel list:', error);
      } finally {
        this.isLoading = false;
      }
    },

    touchValidation() {
      this.$v.selectedChannel.$touch();
    },

    resetValidation() {
      this.$v.selectedChannel.$reset();
    }
  }
};
</script>

<style scoped>
</style>
